module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"product":"Product master","saleZone":"Sale zone master","emptyMasterMessage":"There are no options available for master management."},"es":{"product":"Maestro de productos","saleZone":"Maestro de zonas","emptyMasterMessage":"No hay ninguna opcion disponibles para gestion de maestros"}}')
  delete Component.options._Ctor
}
